import { Address } from '../models/address';

// item 832 — flatten a structured Address to a single display line (street, unit, city, state zip).
// Empty string when nothing's filled in.
export const addressLine = (a?: Address | null): string => {
  if (!a) return '';
  return [a.street, a.unit, a.city, a.state, a.zip]
    .filter((p) => p && String(p).trim())
    .join(', ');
};

export default addressLine;
